import ReactDOM from 'react-dom'
import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Routes from './route.js'
import About from './about.js'



ReactDOM.render(<Routes />, document.getElementById('app'));



/** WEBPACK FOOTER **
 ** src/index.js
 **/